import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { MatDialogModule } from '@angular/material/dialog';
import { SimplebarAngularModule } from 'simplebar-angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { MapComponent } from './components/map/map.component';
import { ProgressHttpInterceptor } from './services/progress.interceptor';
import { MapboxglGraphComponent } from './components/controls/mapboxgl-graph/mapboxgl-graph.component';
import { MapboxglLayerComponent } from './components/controls/mapboxgl-layer/mapboxgl-layer.component';
import { MapboxglSearchComponent } from './components/controls/mapboxgl-search/mapboxgl-search.component';
import { MapboxglChangeStyleComponent } from './components/controls/mapboxgl-change-style/mapboxgl-change-style.component';
import { MapboxglFeatureInfoComponent } from './components/controls/mapboxgl-feature-info/mapboxgl-feature-info.component';
import { MapboxglDrawFeatureComponent } from './components/controls/mapboxgl-draw-feature/mapboxgl-draw-feature.component';

@NgModule({
  declarations: [
    AppComponent,
    MapComponent,
    MapboxglGraphComponent,
    MapboxglLayerComponent,
    MapboxglSearchComponent,
    MapboxglDrawFeatureComponent,
    MapboxglChangeStyleComponent,
    MapboxglFeatureInfoComponent,
  ],
  imports: [
    FormsModule,
    CommonModule,
    BrowserModule,
    MatDialogModule,
    AppRoutingModule,
    HttpClientModule,
    MatProgressBarModule,
    ReactiveFormsModule,
    SimplebarAngularModule,
    BrowserAnimationsModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ProgressHttpInterceptor,
      multi: true,
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
